<template>
  <span> EAAA Member </span>
</template>

<style lang="less" scoped>
span {
  .font-size(11, 18);
  .block();
  .font-medium();
  .uppercase();

  align-self: flex-start;
  color: @color-text-reverse;
  background: linear-gradient(-45deg, transparent 6px, #f47721 6px);
  letter-spacing: 0.03em;
  padding: @4px @20px @3px @18px;
  margin: @9px 0;

  &.meta {
    margin-top: 0;
  }
}
</style>
